import { render } from "./TreeMultiselect.vue?vue&type=template&id=4a89f640&scoped=true&ts=true"
import script from "./TreeMultiselect.vue?vue&type=script&lang=ts"
export * from "./TreeMultiselect.vue?vue&type=script&lang=ts"

import "./TreeMultiselect.vue?vue&type=style&index=0&id=4a89f640&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a89f640"]])

export default __exports__